import { render, staticRenderFns } from "./BrandNameTagChartBar.vue?vue&type=template&id=1a469808"
import script from "./BrandNameTagChartBar.vue?vue&type=script&lang=js"
export * from "./BrandNameTagChartBar.vue?vue&type=script&lang=js"
import style0 from "./BrandNameTagChartBar.vue?vue&type=style&index=0&id=1a469808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports